import { UserT } from 'business/definitions';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import {
    InscriptionGenericPhaseFieldT,
    InscriptionT,
} from 'routes/BudgetModule/shared/entities/inscription';

export enum EventTypes {
    CREATE = 'create',
    UPDATE = 'update',
    SUBCREATE = 'subcreate',
    COMMENT = 'comment',
}

// primitive cannot be modified
export type HistoryOriginT =
    | 'inscription'
    | 'serviceProposal'
    | 'simulatedArbitration'
    | 'supplementaryBudgetInscription'
    | 'arbitrageDmInscription';

export type ResourceEventIdFieldT = 'orgChartFinanceId' | 'gestionnaireId';

type InscriptionEventFieldT =
    | InscriptionGenericPhaseFieldT
    | ResourceEventIdFieldT
    | 'budgetLineSoftwareId'
    | 'enrichedOperationSoftwareId';

export type HistoryUpdateContentT = Record<
    Partial<InscriptionEventFieldT>,
    {
        before: string | number;
        after: string | number;
    }
>;

export type InscriptionEventT = {
    id: number;
    origin: HistoryOriginT;
    content: HistoryUpdateContentT;
    label?: string;
    date: string;
    type: EventTypes;
    user: Pick<UserT, 'email'>;
    inscription: Pick<InscriptionT, 'budgetLineSoftwareId' | 'id'>;
    lastItem?: boolean;
    budgetProposal: BudgetProposalT;
};

export type FullInscriptionEventT = {
    id: number;
    origin?: HistoryOriginT;
    content: HistoryUpdateContentT | string;
    label?: string;
    date: string;
    type: EventTypes;
    user: Pick<UserT, 'email'>;
    inscription: Pick<InscriptionT, 'budgetLineSoftwareId' | 'id'>;
    lastItem?: boolean;
    budgetProposal: BudgetProposalT;
    inscriptionId?: number;
};
